import { RootState } from "../../../system/redux/store/community-finder-redux-store";

/** Selects the Area Info data from the Redux state. */
export const selectAreaInfo = (state: RootState) => state?.areaInfo;
